"use strict";

PF.Field.List = class List extends PF.Field
	{
	static get options()
		{
		return {
			html: PF.Field.Select.templates,

			errors: {}
		};
		}


	init()
		{

		}


	};
